import { Fetch } from '../utils'
import { ApiEndpoints } from '../constants'
import type { GlobalErrorHandler, User, UserProfile } from '..'

export class UserApi {
  fetchInstance: Fetch

  constructor(endpoint: string, token: string, onError?: GlobalErrorHandler) {
    this.fetchInstance = new Fetch(endpoint, token, undefined, onError)
  }

  getUserFeatures = async () => {
    return this.fetchInstance.get(ApiEndpoints.USER_FEATURES).then((data) => data.user_features)
  }

  updateUser = async (user: User) => {
    return this.fetchInstance.put(ApiEndpoints.USER, user).then((data) => data.user)
  }

  updateUserProfile = async (userProfile: UserProfile) => {
    return this.fetchInstance
      .put(`${ApiEndpoints.USER_PROFILES}/${userProfile.guid}`, userProfile)
      .then((data) => data.user_profile)
  }
}
